import { render, staticRenderFns } from "./OtpCodeInput.vue?vue&type=template&id=1501b5ef&scoped=true&"
import script from "./OtpCodeInput.vue?vue&type=script&lang=js&"
export * from "./OtpCodeInput.vue?vue&type=script&lang=js&"
import style0 from "./OtpCodeInput.vue?vue&type=style&index=0&id=1501b5ef&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1501b5ef",
  null
  
)

export default component.exports